import { addCustomEventDataLayer } from './utils';

if (!window.adobeDataLayer) {
    window.adobeDataLayer = [];
}

(function () {
    'use strict';

    function searchEventListener() {
        const searchForm = document.getElementById("header-search");
        searchForm?.addEventListener("submit", (e) => {
            e.preventDefault();

            const searchElement = searchForm.querySelector('#searchSubmit');
            const searchValue = searchForm.querySelector('#searchInput').value;
            addCustomEventDataLayer(searchElement, 'site_search_submit', { "siteSearchTerm": searchValue });
            searchForm.submit();
        });
    }

    if (document.readyState !== "loading") {
        searchEventListener();
    } else {
        document.addEventListener("DOMContentLoaded", searchEventListener);
    }
}());
